class AnnouncementBar extends HTMLElement {
  constructor() {
    super();

    this.currentIndex = 0;
    this.touchStartX = 0;
    this.touchEndX = 0;
    this.timer = null;

    this.goTo = this.goTo.bind(this);
    this.nextAnnouncement = this.nextAnnouncement.bind(this);
    this.previousAnnouncement = this.previousAnnouncement.bind(this);
    this.startTimer = this.startTimer.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.handleTouchStart = this.handleTouchStart.bind(this);
    this.handleTouchEnd = this.handleTouchEnd.bind(this);
    this.hideForOneDay = this.hideForOneDay.bind(this);
  }

  connectedCallback() {
    this.container = this.querySelector('#wt-announcement__container');

    if (!this.container) return;

    this.sectionId = this.container.dataset.sectionId;
    this.total = parseInt(
      this.container.dataset.announcementsCount || '0',
      10
    );

    this.mode = this.container.dataset.displayMode || 'carousel';

    this.autoRotate =
      this.container.dataset.autorotate === 'true';

    this.speed =
      (parseInt(this.container.dataset.speed || '5', 10) || 5) * 1000;

    this.track = this.querySelector(
      '#wow-track-' + this.sectionId
    );

    this.prevButton = this.querySelector(
      '#wow-prev-' + this.sectionId
    );

    this.nextButton = this.querySelector(
      '#wow-next-' + this.sectionId
    );

    this.closeButton = this.querySelector(
      '.wt-announcement__close'
    );

    /*
     * Sluitknop
     */
    if (this.closeButton) {
      this.closeButton.addEventListener(
        'click',
        this.hideForOneDay
      );
    }

    /*
     * Marquee gebruikt uitsluitend CSS.
     */
    if (this.mode === 'marquee') return;

    /*
     * Geen carousel nodig bij één bericht.
     */
    if (!this.track || this.total <= 1) return;

    /*
     * Pijltjes
     */
    if (this.prevButton) {
      this.prevButton.addEventListener(
        'click',
        this.previousAnnouncement
      );
    }

    if (this.nextButton) {
      this.nextButton.addEventListener(
        'click',
        this.nextAnnouncement
      );
    }

    /*
     * Swipe op mobiel/tablet
     */
    this.track.addEventListener(
      'touchstart',
      this.handleTouchStart,
      { passive: true }
    );

    this.track.addEventListener(
      'touchend',
      this.handleTouchEnd,
      { passive: true }
    );

    /*
     * Alleen automatisch roteren in carouselmodus.
     */
    this.startTimer();
  }

  goTo(index) {
    if (!this.track || this.total <= 1) return;

    this.currentIndex =
      (index + this.total) % this.total;

    this.track.style.transform =
      `translateX(-${this.currentIndex * 100}%)`;
  }

  nextAnnouncement() {
    this.goTo(this.currentIndex + 1);
    this.resetTimer();
  }

  previousAnnouncement() {
    this.goTo(this.currentIndex - 1);
    this.resetTimer();
  }

  startTimer() {
    if (
      this.mode !== 'carousel' ||
      !this.autoRotate ||
      this.total <= 1
    ) {
      return;
    }

    clearInterval(this.timer);

    this.timer = setInterval(() => {
      this.goTo(this.currentIndex + 1);
    }, this.speed);
  }

  resetTimer() {
    clearInterval(this.timer);
    this.startTimer();
  }

  handleTouchStart(event) {
    this.touchStartX =
      event.touches[0].clientX;
  }

  handleTouchEnd(event) {
    this.touchEndX =
      event.changedTouches[0].clientX;

    const difference =
      this.touchStartX - this.touchEndX;

    /*
     * Pas wisselen bij een duidelijke swipe.
     */
    if (Math.abs(difference) < 40) return;

    if (difference > 0) {
      this.nextAnnouncement();
    } else {
      this.previousAnnouncement();
    }
  }

  hideForOneDay() {
    const oneDayLater =
      Date.now() + 24 * 60 * 60 * 1000;

    localStorage.setItem(
      'wt-announcement-hidden',
      oneDayLater
    );

    this.style.display = 'none';
  }

  disconnectedCallback() {
    clearInterval(this.timer);

    if (this.prevButton) {
      this.prevButton.removeEventListener(
        'click',
        this.previousAnnouncement
      );
    }

    if (this.nextButton) {
      this.nextButton.removeEventListener(
        'click',
        this.nextAnnouncement
      );
    }

    if (this.track) {
      this.track.removeEventListener(
        'touchstart',
        this.handleTouchStart
      );

      this.track.removeEventListener(
        'touchend',
        this.handleTouchEnd
      );
    }

    if (this.closeButton) {
      this.closeButton.removeEventListener(
        'click',
        this.hideForOneDay
      );
    }
  }
}

if (!customElements.get('announcement-bar')) {
  customElements.define(
    'announcement-bar',
    AnnouncementBar
  );
}

